// extracted by mini-css-extract-plugin
module.exports = {"root":"selector-form-row_root__0i9Hd","selector":"selector-form-row_selector__WcGbB","option":"selector-form-row_option__qVsbf","optionText":"selector-form-row_optionText__nrpEC"};